// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"502":"e1ce41dd","641":"0506600b"}[chunkId] + ".chunk.css";
};